type MachinedColors = { bg: string; hover: string; text: string; disabledBg: string; disabledText: string };

/** A solid fill with a machined bottom edge and one pixel of travel on press, in any colours. */
export const machinedButtonSx = ({ bg, hover, text, disabledBg, disabledText }: MachinedColors) => ({
  borderRadius: '8px',
  fontWeight: 600,
  textTransform: 'none' as const,
  bgcolor: bg,
  color: text,
  boxShadow: 'inset 0 -2px 0 rgba(0,0,0,.22)',
  '&:hover': { bgcolor: hover, boxShadow: 'inset 0 -2px 0 rgba(0,0,0,.22)' },
  '&:active': { transform: 'translateY(1px)', boxShadow: 'inset 0 -1px 0 rgba(0,0,0,.22)' },
  '&.Mui-disabled': { bgcolor: disabledBg, color: disabledText, boxShadow: 'none' },
  '@media (prefers-reduced-motion: reduce)': { '&:active': { transform: 'none' } }
});

/**
 * The funnel's commit-button recipe: solid INK (near-black on light, warm
 * white on dark), a machined bottom edge, one pixel of travel on press.
 * Brand teal keeps meaning selection and state — never the ask itself.
 */
export const inkButtonSx = (dark: boolean) =>
  machinedButtonSx(
    dark
      ? { bg: '#E9EFEB', hover: '#FFFFFF', text: '#0A0C0E', disabledBg: 'rgba(233,239,235,.3)', disabledText: 'rgba(10,12,14,.5)' }
      : { bg: '#131917', hover: '#2A322D', text: '#FFFFFF', disabledBg: 'rgba(19,25,23,.35)', disabledText: 'rgba(255,255,255,.7)' }
  );
